import React from 'react';
import { TimelineMax, Power1 } from "gsap";
import styled from 'styled-components';
const renderHTML = rawHTML => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });

class CardIcon extends React.Component {
  constructor(props) {
    super(props);

    this.timeline = new TimelineMax({ paused: true });
  }

  componentDidMount() {
    const { delay, itemId } = this.props;

    this.timeline
      .from(this.card, 1.2, {
        autoAlpha: 0,
        y: 20,
        ease: Power1.ease,
        delay: delay * itemId + 1
      })

    this.timeline.play();
  }

  render() {
    const { icon, heading, text } = this.props;
    return (
      <StyledCardIcon ref={card => (this.card = card)}>
        <Icon>{renderHTML(icon)}</Icon>
        <Heading>{heading}</Heading>
        <Text>{text}</Text>
      </StyledCardIcon>
    )
  }
}

const StyledCardIcon = styled.div`
  width: 33%;
  margin-bottom: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;

  svg {
    width: 50px;
    height: 50px;
  }
`

const Icon = styled.div`
  margin-bottom: 20px;
`

const Heading = styled.h3`
  text-transform: uppercase;
  margin-bottom: 15px;
`

const Text = styled.p`
  padding: 0 40px;
  text-align: center;
  font-size: 18px;
`

export default CardIcon;